<template>
    <div class="finance">
      <banner clazz="finance-banner" url="finance" hasDivider>
        <template slot="buttons">
          <el-button class="banner-button" round @click="goRegister('caiwu-banner-tiyan')">申请体验</el-button>
          <el-button class="banner-button" round @click="this.goConsult">立即咨询</el-button>
        </template>
      </banner>
      <div class="finance-section1">
        <div class="container">
          <div class="section1-content">
            <img class="section1-img" src="../../assets/img/finance/peitu.png"  alt="简化财务人员对账"/>
            <div class="section1-misc">
              <div class="misc-title">
                <p>简化财务人员对账</p>
                <p>高效，准确，便捷</p>
              </div>
              <div class="misc-divider"></div>
              <p class="misc-content">
                财务对账是企业采购工作中一项繁杂、易出错的工作
                ，企业与供应商之间需要核对对账周期中发生的货物入库、发票、往来货款情况。
                ERP系统是企业的主要财务管理工具，甄云采购系统中的的财务版块可通过与ERP系统的对接，
                帮助企业实现对账、发票校验、资金计划、付款申请等过程的管理。
              </p>
              <hover-button clazz="consult-button" text="立即咨询" @click.native="goConsult"></hover-button>
            </div>
          </div>
        </div>
      </div>

      <div class="finance-section2">
        <div class="item-list">
          <div class="tc">
            <h1 class="item-list-title">切合财务需求，优化财务办公</h1>
            <div class="dib tl border-bottom"></div>
          </div>
          <div class="item-tab">
            <el-tabs type="border-card" stretch>
              <el-tab-pane label="改善数据准确性">
                <div class="rel clearfix content">
                  <div class="fl tl left-list">
                    <h2 class="title">改善数据准确性</h2>
                    <div class="border-bottom-tab"></div>
                    <p class="left-desc">
                      甄云财务对账系统通过与订单协同系统衔接，可入库数据、对账数据、发票数据的关联，关键信息在系统中传递，改善数据准确性。
                    </p>
                  </div>
                  <div class="fr rel right-list">
                    <div class="right-img">
                      <img src="../../assets/img/finance/peitu1.png" alt="改善数据准确性">
                    </div>
                    <div class="abs right-bg rbg01"></div>
                  </div>
                </div>
              </el-tab-pane>
              <el-tab-pane label="对账顺序">
                <div class="clearfix content">
                  <div class="fl tl left-list">
                    <h1 class="title">对账顺序</h1>
                    <div class="border-bottom-tab"></div>
                    <p class="left-desc">
                      甄云财务对账系统可为企业提供账龄、供应商账/付款条件等数据，帮助企业确定付款顺序。
                    </p>
                  </div>
                  <div class="fr rel right-list">
                    <div class="right-img">
                      <img src="../../assets/img/finance/peitu2.png" alt="对账顺序">
                    </div>
                    <div class="abs right-bg rbg02"></div>
                  </div>
                </div>
              </el-tab-pane>
              <el-tab-pane label="支持不同付款对象">
                <div class="clearfix content">
                  <div class="fl tl left-list">
                    <h1 class="title">支持不同付款对象</h1>
                    <div class="border-bottom-tab"></div>
                    <p class="left-desc">
                      企业实际的采购业务中存在两种履约的单据：单笔合同及订单，对应两种不同的付款方式：单笔合同按阶段付款，订单按照入库付款。甄云财务系统支持基于合同付款阶段、已对账的入库数据开具发票、发票校验、及付款申请。
                    </p>
                  </div>
                  <div class="fr rel right-list">
                    <div class="right-img">
                      <img src="../../assets/img/finance/peitu3.png" alt="支持不同付款对象">
                    </div>
                    <div class="abs right-bg rbg03"></div>
                  </div>
                </div>
              </el-tab-pane>
              <el-tab-pane label="支持扣款管理">
                <div class="clearfix content">
                  <div class="fl tl left-list">
                    <h2 class="title">支持扣款管理</h2>
                    <div class="border-bottom-tab"></div>
                    <p class="left-desc">
                      对账系统支持对由于质量问题、交期延迟、交货数量不准确产生的对供应商的处罚扣款进行管理，支持供应商在线确认及反馈，帮助企业避免由于扣款过程中的误差及纠纷。
                    </p>
                    <!-- <div class="left-link">
                      <div class="left-link-item">
                        <span></span>
                        根据公认的成本重新开票
                      </div>
                      <div class="left-link-item">
                        <span></span>
                        关闭发票的重新开票（可能在申请时进入）
                      </div>
                      <div class="left-link-item">
                        <span></span>
                        在内部时间表（内部CRA）上重新开票
                      </div>
                    </div> -->
                  </div>
                  <div class="fr rel right-list">
                    <div class="right-img">
                      <img src="../../assets/img/finance/peitu4.png" alt="支持扣款管理">
                    </div>
                    <div class="abs right-bg rbg04"></div>
                  </div>
                </div>
              </el-tab-pane>
              <el-tab-pane label="规范">
                <div class="clearfix content">
                  <div class="fl tl left-list">
                    <h2 class="title">规范</h2>
                    <div class="border-bottom-tab"></div>
                    <p class="left-desc">
                      甄云财务对账系统可帮助企业建立规范的对账请款流程，帮助企业规避过程中的各种问题：对账数据错误、发票丢失、付款不及时等。
                    </p>
                  </div>
                  <div class="fr rel right-list">
                    <div class="right-img">
                      <img src="../../assets/img/finance/peitu5.png" alt="规范">
                    </div>
                    <div class="abs right-bg rbg05"></div>
                  </div>
                </div>
              </el-tab-pane>
            </el-tabs>
          </div>
        </div>
        <div class="item-list2"></div>
      </div>
    </div>
</template>

<script>
import hoverButton from '../common/hoverButton.vue'
import banner from '../common/banner.vue'
export default {
  inject: ['openRegister', 'goConsult'],
  name: 'Finance',
  metaInfo () {
    return {
      title: this.$seo.finance.title, // set a title
      meta: [{ // set meta
        name: 'keywords',
        content: this.$seo.finance.keywords
      },
      {
        name: 'description',
        content: this.$seo.finance.description
      }]
    }
  },
  components: {
    hoverButton,
    banner
  },
  data () {
    return {
    }
  },
  methods: {
    goRegister (code) {
      this.openRegister(false, code)
    }
  },
  created () {
  }
}
</script>

<style lang="scss">
  @import "../../../static/css/finance.scss";
</style>



// WEBPACK FOOTER //
// finance.vue?564cd8c9